<div class="card" style="height: 100%; margin: 0px; background-color: #fff;">
  <!-- A line may break after each separator of the name ('dcnetscope_test_update_archive_template'), and anywhere
       in a name holding none, so that a long name wraps inside the box rather than running out of it -->
  <div class="card-header member-name" [title]="appGroup.name"
       style="color: #333; font-size: clamp(6px, 6cqi, 12px);">
    @for (part of nameParts(); track $index) {
      <span>{{ part }}</span><wbr>
    }
  </div>
<!--  <div class="card-block">-->
<!--  </div>-->

</div>
